import React from 'react'
import { PieChart as RechartPieChart, Legend, ResponsiveContainer, Pie } from 'recharts'

export type PieChartData = any[]

interface PieChartProps {
  width: number
  height: number
  data: PieChartData
}

const PieChart: React.FC<PieChartProps> = ({ width, height, data }) => (
  <ResponsiveContainer
    width="100%"
    height={height}
  >
    <RechartPieChart
      width={width}
      height={height}
      data={data}
    >
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={50}
        fill="#8884d8"
      />
      <Legend />
    </RechartPieChart>
  </ResponsiveContainer>
)

export default PieChart
